<template>
    <span class="mr-2" :class="[getCashoutStatusClass(status), sizeClass]">
        {{ getCashoutStatusName(status) }}
    </span>
</template>

<script>
import BankMixin from "../../mixins/BankMixin.vue";
export default {
    props: {
        status: {
            type: String,
        },
        size: {
            type: String,
            default: "md",
        },
    },

    mixins: [BankMixin],

    computed: {
        sizeClass() {
            return this.size === "md" ? "" : "text-[11px]";
        },
    },
};
</script>
